import { FavouriteAdminTranslation } from 'app/area/favourite-administration/constants';
import { ChangeOptionType } from 'app/area/favourite-administration/list/types';
import { FavouriteAdminListState } from 'app/area/favourite-administration/list/types-store';
import { FilterOption } from 'app/components/options-handler/types';
import { LoadOptions } from 'app/types-shared';
import { ValidationProps } from 'ui';

export enum ChangeUserGroupsField {
  replaceExistingUserGroups = 'replaceExistingUserGroups',
  applyOnDescendants = 'applyOnDescendants'
}

export interface ChangeUserGroupsComponentProps {
  list: FavouriteAdminListState;
  options: {
    [key: string]: FilterOption;
  };
  translation: FavouriteAdminTranslation;
  validation: { [key: string]: ValidationProps };
  locale: string;
  onClose: () => void;
  save: () => void;
  updateByKey: <T>(key: string, value: T) => void;
  resetValidation: (key: string) => void;
  updateIsDirty: (value: boolean) => void;
  updateState: (value: ChangeOptionType) => void;
  clearChangeUserGroups: () => void;
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
}
